<template>
  <input
      type="text"
      v-model="displayValue"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="handleInput"
      @keydown.delete="handleDelete"
      class="form-input text-center dark-input"
      dir="rtl"
      placeholder="YYYY-MM-DD"
      maxlength="10"
      style="text-align: right"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rawValue: '',
      isFocused: false
    }
  },
  computed: {
    displayValue: {
      get() {
        if (this.isFocused) {
          return this.formatForDisplay(this.rawValue)
        }
        return this.value
      },
      set(newValue) {
        this.rawValue = newValue.replace(/\D/g, '')
      }
    }
  },
  methods: {
    handleFocus() {
      this.isFocused = true
      if (this.value && this.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const parts = this.value.split('-')
        this.rawValue = parts[0] + parts[1] + parts[2]
      } else {
        this.rawValue = ''
      }
    },
    handleBlur() {
      this.isFocused = false
      this.formatAndEmit()
    },
    handleInput(event) {
      let value = event.target.value.replace(/\D/g, '')

      if (value.length === 2 && this.rawValue.length < 2) {
        value += '-'
      }
      else if (value.length === 5 && this.rawValue.length < 5) {
        value = value.slice(0, 5) + '-'
      }

      this.rawValue = value.slice(0, 8) // Limit to DDMMYYYY

      if (this.rawValue.length === 8) {
        this.formatAndEmit()
      }
    },
    handleDelete() {
      // Allow proper deletion of characters including slashes
      setTimeout(() => {
        // If deleting a slash, remove the preceding digit too
        if (this.displayValue.slice(-1) === '-') {
          this.rawValue = this.rawValue.slice(0, -1)
        }
        this.rawValue = this.rawValue.slice(0, -1)
      }, 0)
    },
    formatForDisplay(value) {
      if (!value) return ''

      let formatted = value
      if (value.length > 2) {
        formatted = value.slice(0, 2) + '-' + value.slice(2)
      }
      if (value.length > 4) {
        formatted = formatted.slice(0, 5) + '-' + formatted.slice(5)
      }
      return formatted
    },
    formatAndEmit() {
      if (this.rawValue.length === 8) {
        const day = this.rawValue.slice(0, 2)
        const month = this.rawValue.slice(2, 4)
        const year = this.rawValue.slice(4, 8)

        // Validate day (1-31)
        const validDay = Math.min(Math.max(parseInt(day, 10), 1), 31)
            .toString()
            .padStart(2, '0')

        // Validate month (1-12)
        const validMonth = Math.min(Math.max(parseInt(month, 10), 1), 12)
            .toString()
            .padStart(2, '0')

        const validYear = parseInt(year, 10)
            .toString()
            .padStart(4, '0')

        const formattedDate = `${validYear}-${validMonth}-${validDay}`
        this.$emit('input', formattedDate)
      }
    }
  }
}
</script>

<style scoped>
.dark-input {
  background-color: #1a1a1a;
  color: white;
  border: 2px solid #0066cc;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.dark-input:focus {
  outline: none;
  border-color: #4d94ff;
  box-shadow: 0 0 5px rgba(77, 148, 255, 0.5);
  background-color: #2a2a2a;
}

.dark-input::placeholder {
  color: #666;
  opacity: 1;
}

.dark-input:hover {
  border-color: #4d94ff;
}
</style>